import React from 'react';
// Font Awesome 아이콘 import
import { FaHome, FaTshirt, FaIdCard, FaStar, FaUser } from 'react-icons/fa'; 

// 아이콘 매핑 테이블: 외부에서 문자열로 아이콘 이름을 넘길 수 있게 정의 (선택 사항)
const IconMap = {
    'home': FaHome,
    'tshirt': FaTshirt,
    'id-card': FaIdCard,
    'star': FaStar,
    'user': FaUser,
};

/**
 * 화면 하단에 고정되는 재사용 가능한 내비게이션 바 컴포넌트
 * @param {string} activePath - 현재 활성화된 페이지의 경로 (예: '/')
 * @param {Array<Object>} items - 내비게이션 항목 배열
 */
const BottomNavBar = ({ activePath, items, onItemClick }) => {
    
    return (
        <div style={styles.navBar}>
            {items.map((item, index) => {
                // Props로 받은 아이콘 이름을 실제 컴포넌트로 매핑
                const NavIcon = item.iconComponent || IconMap[item.iconName];
                // 현재 경로와 일치하는지 확인
                const isActive = activePath === item.path;

                return (
                    <div 
                        key={index} 
                        onClick={() => onItemClick(item.path)} // 클릭 시 콜백 함수 호출
                        style={styles.navItem}
                    >

                    { isActive ?
                    <img 
                    src={`${process.env.PUBLIC_URL}/${item.iconName}.png`} // public 폴더 경로

                    style={{width:'15pt', filter: 'grayscale(100%) brightness(0)',}} 
                    />:
                    <img 
                    src={`${process.env.PUBLIC_URL}/${item.iconName}.png`} // public 폴더 경로

                    style={{width:'15pt'}} 
                    />

                    }


                        {/* {NavIcon && (
                            <NavIcon 
                                size={22} 
                                // 활성화 상태에 따른 색상 변경
                                color={isActive ? styles.colors.active : styles.colors.inactive} 
                            />
                        )} */}
                        <span style={{ 
                            ...styles.navText, 
                            color: isActive ? styles.colors.active : styles.colors.inactive,
                            fontWeight: isActive ? 'bold' : 'normal'
                        }}>
                            {item.name}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

// ----------------------------------------------------
// 스타일 정의 (고정)
// ----------------------------------------------------
const styles = {
    colors: {
        active: '#000', // 활성화 시 검은색
        inactive: '#888', // 비활성화 시 회색
    },
    navBar: {
        position: 'fixed', 
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        maxWidth: '420px', 
        height: '60px',
        backgroundColor: '#fff',
        borderTop: '1px solid #ddd',
        boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.05)',
        zIndex: 100,
        margin: '0 auto', // maxWidth 중앙 정렬
        display: 'flex',
        justifyContent: 'space-around', 
        alignItems: 'center',
    },
    navItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        padding: '5px 0',
        cursor: 'pointer',
    },
    navText: {
        fontSize: '10px',
        marginTop: '3px',
    },
};

export default BottomNavBar;